import {NUMBER} from '@drivesally/sally-fw/lib/inputTypes';

// attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

// types
import amount from '@drivesally/sally-fw/lib/type/types/amount.type';
import formattedNumber from '@drivesally/sally-fw/lib/type/types/formattedNumber.type';
import number from '@drivesally/sally-fw/lib/type/types/number.type';

export default attribute({
  type: NUMBER,
  attribute: 'weekly_safetyscore_budget',
  display: amount,
  input: formattedNumber,
  api: number,
  label: {
    default: 'Weekly Safety Score Budget',
    short: 'Weekly Safety Score Budget',
  },
});
